import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Bonus } from '../../../../benefit-bonus/bonus/bonus.model';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { SwalHelper } from '../../../../shared/common/SwalHelper';
import { AttendanceService } from '../../../services/attendance.service';
import { CreateEditEmployeeBonusModalComponent } from '../../partials/create-edit-employee-bonus-modal/create-edit-employee-bonus-modal.component';
import { EmployeeAttendanceOverview } from '../employee-attendance-document-employee-detail/employee-attendance-document-employee-detail.component';

@Component({
    selector: 'app-toggle-attendance-approvement',
    templateUrl: './toggle-attendance-approvement.component.html',
    styleUrls: ['./toggle-attendance-approvement.component.css']
})
export class ToggleAttendanceApprovementComponent {
    @Input() public date: Date;
    @Input() public employees: any;
    @Input() public employeeDatetimeId: number;
    @Input() public overview: EmployeeAttendanceOverview;

    @Output() public stateChanged = new EventEmitter<void>();

    public loggedUser = this._authService.loggedUser;
    public isEmployeeApproval = false;

    public constructor(
        private _attendanceService: AttendanceService,
        private _authService: AuthenticationService,
        private _modalService: NgbModal,
        private _swalHelper: SwalHelper,
    ) { }

    public async toggleApprovement(approve = true): Promise<void> {
        this.isEmployeeApproval = this.overview?.employee?.employee_ID === this.loggedUser.employee?.employee_ID;
        let employeeIds: number[] = null;

        if (typeof this.employees === 'number') {
            employeeIds = [this.employees];
        }
        if (Array.isArray(this.employees)) {
            employeeIds = this.employees.map(employee => employee.employee_ID);
        }

        const formattedDate = `${this.date.getFullYear()}-${String(this.date.getMonth() + 1).padStart(2, '0')}-${String(this.date.getDate()).padStart(2, '0')}`;

        const isConfirmed = this.overview?.show_bonus_modal ? true : (await this._swalHelper.showConfirmChangeDialog('employees_datetimes.attendance_approvement_text', 'employees_datetimes.attendance_approvement_title'));

        if (isConfirmed) {
            this._attendanceService.toggleAttendanceApproval(approve, employeeIds, formattedDate, this.isEmployeeApproval)
                .then(() => {
                        if (this.isEmployeeApproval && this.overview?.show_bonus_modal) {
                            const modalRef = this._modalService.open(CreateEditEmployeeBonusModalComponent, {centered: true});

                            modalRef.componentInstance.employee = this.overview.employee;
                            modalRef.componentInstance.isAttendanceBonus = true;
                            modalRef.componentInstance.bonus = {
                                name: 'Bonus',
                                date: moment(formattedDate).add(1, 'month').format('YYYY-MM-DD'),
                                type: 'MONTHLY'
                            } as Bonus;

                            modalRef.result.finally(
                                () => this.stateChanged.emit(),
                            );
                        } else {
                            this.stateChanged.emit();
                        }
                    },
                    () => {}
                );
        }
    }
}
